/**
 * Removes duplicate .nb-block-slot nodes for the same data-section-id inside the active root.
 * Keeps the last mount (current React tree); drops preserved Activity ghosts.
 */

import { getActiveNotebookRoot } from './notebook-route-root'
import { nbWarn } from './notebook-debug'

/**
 * @param {ParentNode | null | undefined} [scope]
 * @returns {number} removed count
 */
export function dedupeNotebookBlockSlots(scope = null) {
  if (typeof document === 'undefined') return 0

  const root =
    scope instanceof Element
      ? scope
      : getActiveNotebookRoot() ??
        document.querySelector('.nb-root[data-nb-route-root]')

  if (!root) return 0

  const slots = [...root.querySelectorAll('.nb-block-slot[data-section-id]')]
  const lastById = new Map()

  for (const slot of slots) {
    const id = slot.getAttribute('data-section-id')
    if (!id) continue
    lastById.set(id, slot)
  }

  let removed = 0
  for (const slot of slots) {
    const id = slot.getAttribute('data-section-id')
    if (!id) continue
    if (lastById.get(id) !== slot) {
      slot.remove()
      removed += 1
    }
  }

  if (removed > 0) {
    nbWarn('Removed duplicate notebook block slots (same section id)', {
      removed,
      uniqueIds: lastById.size,
    })
  }

  return removed
}

/** DOM-only reconcile — removes ghost slots; does not mutate layout metrics. */
export function reconcileNotebookBlockSlots(scope = null) {
  return dedupeNotebookBlockSlots(scope)
}
